
<script>
import vSearch from './vSearch'
import {crud, vSearchMixin} from 'crud-vue-core'

crud.conf['v-search-constraint'] = {
    confParent: 'v-search',
    routeName: 'search-constraint',
    buttonsClass : 'text-left',
    advancedVisible : false,
}



export default {
  name: 'v-search-constraint',
  extends: vSearch,
  methods: {
      setRouteValues: function (route) {
          var that = this
          route.setValues({
              modelName: that.modelName,
              constraintKey: that.constraintKey,
              constraintValue: that.constraintValue
          })
          return route
      }
  }
}
</script>

<style scoped>

</style>
